import { APP_URL } from '../constants'

export const buildTwitterIframeSrc = (url) => {
    return APP_URL() + '/externals/twitterwidget.html?code=' + encodeURIComponent(url)
}